@if (isVisible) {
    <div class="dialog-wrapper">
        <ng-container *ngTemplateOutlet="!hasDestinationSelector ? srcTabTmpl : tabbedViewTmpl"></ng-container>
    </div>
}

<ng-template #srcTabTmpl>
    @if (selectedTabIndex === 0) {
        <adspt-global-filter-selector-list
            [hasAdvancedMode]="enableAdvancedMode"
            [enabledApplySection]="enableAdvancedFilterSelection"
            [subfilterOptions]="subfilterOptions"
            [defaultSubfiltersValues]="obs.data.defaultSubfilters[0]"
            [texts]="obs.translations"
            [loading]="obs.listLoader"
            [data]="srcList | async"
            [count]="srcTotalCount | async"
            [selectedItem]="obs.data.src.type === 'SELECTED_ITEM' && obs.data.src.payload"
            [template]="rowItemTmpl"
            [disableResetActions]="!(hasSrcQuery | async)"
            [heapInfo]="heapInfo"
            [isDestinationFilterMode]="false"
            (notfiy)="notfiy.emit({ evt: $event, filterMode: filterMode.Source })"
            (refinerChange)="refinerChange.emit({ evt: $event, filterMode: filterMode.Source })"
        />
    }
</ng-template>

<ng-template #destTabTmpl>
    @if (selectedTabIndex === 1) {
        <adspt-global-filter-selector-list
            [hasAdvancedMode]="enableAdvancedMode"
            [enabledApplySection]="enableAdvancedFilterSelection"
            [defaultSubfiltersValues]="obs.data.defaultSubfilters[1]"
            [subfilterOptions]="subfilterOptions"
            [texts]="obs.translations"
            [data]="destList | async"
            [loading]="obs.listLoader"
            [count]="destTotalCount | async"
            [selectedItem]="obs.data.dest.type === 'SELECTED_ITEM' && obs.data.dest.payload"
            [template]="rowItemTmpl"
            [disableResetActions]="!(hasDestQuery | async)"
            [heapInfo]="heapInfo"
            [isDestinationFilterMode]="true"
            (notfiy)="notfiy.emit({ evt: $event, filterMode: filterMode.Destination })"
            (refinerChange)="refinerChange.emit({ evt: $event, filterMode: filterMode.Destination })"
        />
    }
</ng-template>

<ng-template #tabbedViewTmpl>
    <nz-tabset
        [nzSelectedIndex]="selectedTabIndex"
        (nzSelectedIndexChange)="selectedTabIndex = $event; selectedTabIndexChange.emit($event)"
    >
        <nz-tab [nzTitle]="'global-filter.source' | translate">
            <ng-container *ngTemplateOutlet="srcTabTmpl" />
        </nz-tab>
        <nz-tab [nzTitle]="'global-filter.destination' | translate">
            <ng-container *ngTemplateOutlet="destTabTmpl" />
        </nz-tab>
    </nz-tabset>
</ng-template>
